/* eslint-disable */
/// This file is auto generated - do not edit manually
export const GeneralError = 'Website.Shared.Error.GeneralError';
export const GeneralExceptionError = 'Website.Shared.Error.GeneralExceptionError';
export const TryAgain = 'Website.Shared.Error.TryAgain';
export const GeneralGeolocationPositionErrorMessage = 'Website.Shared.Error.GeneralGeolocationPositionErrorMessage';
